/*
=====================================================================================
  PERSISTÊNCIA DE CARRINHO v.3.0 - SEM RECARREGAMENTO (Client-Side Rendering)
=====================================================================================
  OBJETIVO: Restaurar o carrinho abandonado instantaneamente, sem recarregar a
  página, atualizando apenas o ícone do carrinho e o conteúdo do drawer.
=====================================================================================
*/
(function() {
  const CART_STORAGE_KEY = 'persistent_cart_final_v3_0';
  let isNavigatingToCheckout = false;
  let saveTimeout;

  // --- FUNÇÕES DE SALVAMENTO (sem alterações) ---
  function triggerSave() {
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(saveCartToStorage, 750);
  }

  function saveCartToStorage() {
    if (isNavigatingToCheckout) return;
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count > 0) {
          localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
        } else {
          localStorage.removeItem(CART_STORAGE_KEY);
        }
      });
  }

  // --- NOVA FUNÇÃO DE RESTAURAÇÃO (O CORAÇÃO DA MUDANÇA) ---
  function restoreCartWithoutReload() {
    const storedCartJSON = localStorage.getItem(CART_STORAGE_KEY);
    if (!storedCartJSON) return;

    const storedCart = JSON.parse(storedCartJSON);

    fetch('/cart.js')
      .then(response => response.json())
      .then(currentCart => {
        if (currentCart.item_count === 0 && storedCart && storedCart.items.length > 0) {
          const itemsToAdd = storedCart.items.map(item => ({ id: item.variant_id, quantity: item.quantity }));

          // 1. Restaura o carrinho silenciosamente em segundo plano
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          })
          .then(response => response.json())
          .then(restoredCart => {
            if (restoredCart && restoredCart.items) {
              // 2. ATUALIZAÇÃO MANUAL: Dispara o evento que o tema usa para se atualizar
              // Este evento diz ao tema: "Ei, o carrinho mudou! Atualize o ícone e o drawer."
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: restoredCart } // Passa o novo carrinho para o tema
              }));

              // 3. Se o usuário estiver na página /cart, aí sim recarregamos, pois a página inteira precisa mudar.
              if (window.location.pathname.includes('/cart')) {
                window.location.reload();
              }
              
              // 4. Limpa o backup para não ser usado novamente
              localStorage.removeItem(CART_STORAGE_KEY);
            }
          })
          .catch(error => console.error('[Persist Cart] Erro ao restaurar:', error));
        }
      });
  }

  // --- GATILHOS (EVENT LISTENERS) ---

  // 1. GATILHO DE RESTAURAÇÃO: Roda o mais cedo possível.
  document.addEventListener('DOMContentLoaded', restoreCartWithoutReload);

  // 2. GATILHOS DE SALVAMENTO (sem alterações)
  document.addEventListener('product:added', triggerSave);
  document.addEventListener('cart:refresh', triggerSave);

  document.body.addEventListener('click', function(event) {
    if (event.target.closest('[data-action*="quantity"], .cart-item__remove-button, a[href*="/cart/change"]')) {
      triggerSave();
    }
  });
  document.body.addEventListener('change', function(event) {
    if (event.target.matches('input[name^="updates"], .quantity-selector__value')) {
      triggerSave();
    }
  });
  
  document.body.addEventListener('click', function(event) {
    const checkoutButton = event.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (checkoutButton) {
      isNavigatingToCheckout = true;
      saveCartToStorage();
    }
  }, true);

})();
/* ===== FIM: CÓDIGO DE PERSISTÊNCIA DE CARRINHO v.3.0 ===== */
